import { Injectable } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { GoogleStoragePreviewComponent } from "../components/google-storage-preview/google-storage-preview.component";

@Injectable({
  providedIn: "root",
})
export class GoogleStoragePreviewService {
  constructor(private modalService: NgbModal) {}

  open(signedUrl: string, title: string = "Vista previa del documento"):
    NgbModalRef {
    const modalRef = this.modalService.open(GoogleStoragePreviewComponent, {
      centered: true,
      size: "xl",
      scrollable: true,
      backdrop: "static",
    });

    modalRef.componentInstance.signedUrl = signedUrl;
    modalRef.componentInstance.title = title;

    return modalRef;
  }
}
